import type { WixComponentManifest } from '../schema';
import type { ComponentManifestValidatorResponse } from '../validator';

const constants = {
  notFetcherError: 'ComponentManifestResolver: fetchManifest function is not defined',
  failedMergingError: ({
    mainManifest,
    referredManifest,
    errors
  }: {
    mainManifest: WixComponentManifest;
    referredManifest: WixComponentManifest;
    errors: ComponentManifestValidatorResponse['errors'];
  }) =>
    `Error: Failed merging between ${JSON.stringify(mainManifest)} to ${JSON.stringify(referredManifest)}\nErrors : ${JSON.stringify(errors)}`
};

export default constants;
